import {
  ADD_COMPANY,
  DASHBOARD,
  INCOMLEND_INTERNAL,
  INCOMLEND_INTERNAL_LINK,
  NEW_USER,
  ONBOARDING,
  REGISTERED,
} from "codes";
import history from "./history";

// eslint-disable-next-line prefer-regex-literals
export const isUUID = new RegExp(
  /[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}/
);

const ADMIN_APP_STATE_LINK_MAP: { [x: string]: string } = {
  [ONBOARDING]: DASHBOARD,
  [REGISTERED]: DASHBOARD,
  [NEW_USER]: ADD_COMPANY,
};

export const redirect = async (language = "en") =>
  history.push(`${DASHBOARD}?lang=${language}`);

// Check if we're in the login flow
const isInLoginFlow = () => {
  const path = window.location.pathname;
  return path === "/login" || path === "/";
};

export const roleRedirect = (ROLE: string) => {
  if (typeof window === "undefined" || !window.requestAnimationFrame) return;

  // Delay to next tick (after render)
  requestAnimationFrame(() => {
    if (isInLoginFlow()) return;

    history.replace(
      ROLE === INCOMLEND_INTERNAL
        ? INCOMLEND_INTERNAL_LINK
        : ROLE === "" ? ADD_COMPANY : DASHBOARD
    );
  });
};

export const userRedirect = (APP_STATE: string) => {
  // If we're in login flow, let the login page handle the redirect
  if (isInLoginFlow()) {
    return;
  }
  
  history.replace(ADMIN_APP_STATE_LINK_MAP[APP_STATE]);
};

export default { redirect, isUUID, roleRedirect, userRedirect };
